// extracted by mini-css-extract-plugin
module.exports = {"toast":"index__toast___3_QIH","text":"index__text___rQx_m","icon":"index__icon___2eV8b","warning":"index__warning___1rZ2C","pass":"index__pass___2avh2"};